<template>
  <vs-popup class="vs-con-loading__container create-staff-group-popup" id="popup" title="CREATE USER ROLE"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickGroupCreate)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Role Name</small>
                <vs-input v-model="createGroup.name" name="name" class="w-full required" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <small class="label">Role Description</small>
              <vs-textarea v-model="createGroup.description" height="100px" />
            </div>
          </div>
          <h3 class="mt-4 mb-10">Role Permisions</h3>
          <div class="vx-row my-6">
            <div class="vx-col w-full">
              <vs-checkbox @input="onInputSelectAll()" class="float-right" v-model="is_select_all">Select
                All</vs-checkbox>
            </div>
          </div>
          <div class="vx-row mb-10 text-sm" v-for="(group, index) in allPermissions" :key="index">
            <div class="vx-col w-1/5">
              <b>{{ group.group_label }}</b>
            </div>
            <div class="vx-col w-4/5">
              <div class="vx-row">
                <div class="vx-col w-1/4" v-for="(permission, index) in group.permissions" :key="index">
                  <vs-checkbox v-model="createGroup.permissions" :vs-value="permission">
                    {{ capitalizeWords(permission) }}
                  </vs-checkbox>
                </div>
              </div>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import vSelect from 'vue-select'

const PermissionRepository = RepositoryFactory.get('permissions');
const RolesRepository = RepositoryFactory.get('roles');
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    allPermissions: [],
    dataSource: [],
    createGroup: {
      name: '',
      description: '',
      permissions: []
    },
    fields: {},
    realTimeCheckedNodeCreate: [],
    is_select_all: false
  }
}

export default {
  name: 'CreateStaffGroupPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],

  methods: {
    async openPopup() {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.open = true;
        this.$vs.loading();
        await this.$forceUpdate()
        await this.initialize()
        this.$vs.loading.close()
      } catch (error) {
        this.$vs.loading.close()
      }
    },
    onInputSelectAll() {
      this.createGroup.permissions = this.is_select_all ? this.allPermissions.map(group => group.permissions).flat() : []
    },
    async onClickGroupCreate() {
      const vue = this;
      this.$vs.loading();
      try {
        if (this.createGroup.permissions.length !== 0) {
          await RolesRepository.createRole(this.createGroup);
          this.showSuccessMessage('New staff group was successfully created!')
          this.open = false;
        } else {
          this.$vs.loading.close();
          this.showErrorMessage('Please select the permissions for the group')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
      await vue.$parent.refreshData()
    },

    async initialize() {
      try {
        const { data } = (await PermissionRepository.get()).data;
        console.log(data);
        this.allPermissions = data
      } catch (e) {
        console.log(e.message);
        this.showErrorMessage('Something went wrong!')
      }
    },
    capitalizeWords(str) {
      return str.replace(/\b\w/g, char => char.toUpperCase()).replaceAll('-', ' ')
    },
    async onClickReset() {
      this.$vs.loading();
      await this.initialize()
      this.createGroup = {}
      this.$vs.loading.close();
    }
  },
  async mounted() {

  },
  components: {
    'v-select': vSelect,
  },
  watch: {
    filteredData(val) {
      this.total = val.length
    }
  },
  computed: {

  },
}
</script>

<style scoped>
.create-staff-group-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}
</style>
